import Loading from "shared/loading";
import { clearNotifications } from "./notifications";

export function initListeners(view) {
  view.listenTo(view.model, 'sync error', function() {
    clearNotifications();
    Loading.hide();
  }, view);

  view.listenTo(view.model, 'request', function() {
    clearNotifications();
    Loading.show(view.$(".panel"));
  }, view);
}
